import options from './chart-counting.component';

export default {
    selector: 'dtChartCounting',
    options
};